const allHeaders = {
  date: { headerName: 'Date', field: 'date' },
  name: { headerName: 'Name', field: 'name' },
  shift: { headerName: 'Shift', field: 'shift' },
  reason: { headerName: 'Reason', field: 'reason' },
  quantity: { headerName: 'Quantity', field: 'quantity' },
};

const headers = {
  base: {
    Date: [
      allHeaders.name,
      allHeaders.shift,
      allHeaders.reason,
      allHeaders.quantity,
    ],
    Emp: [
      allHeaders.date,
      allHeaders.shift,
      allHeaders.reason,
      allHeaders.quantity,
    ],
  },
  overtime: {
    Date: [
      allHeaders.date,
      allHeaders.name,
      allHeaders.shift,
      allHeaders.quantity,
    ],
    Emp: [allHeaders.date, allHeaders.shift, allHeaders.quantity],
  },
};

export const useHeaders = (headerType, groupby) => headers[headerType][groupby];
